import { renewAT } from '../../../utils/TokenHelper';

export default async function renewToken() {
    await renewAT();
    const event = new Event('renew-token');
    window.dispatchEvent(event);
}
